var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.803,
    height: 15.803,
    viewBox: "0 0 15.803 15.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5,
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M9.9,2a7.9,7.9,0,1,0,7.9,7.9A7.9,7.9,0,0,0,9.9,2Zm0,14.222A6.321,6.321,0,1,1,16.222,9.9,6.321,6.321,0,0,1,9.9,16.222Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M11.148,6a.79.79,0,0,0-.79.79v3.627L8.217,12.55a.79.79,0,1,0,1.114,1.114l2.37-2.37a.79.79,0,0,0,.237-.553V6.79A.79.79,0,0,0,11.148,6Z",
    transform: "translate(-1.247 -0.839)",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.767ae6f1f9891125bf3b0ecd656ad6ce.svg";
export { ForwardRef as ReactComponent };